import { useMutation } from 'react-query';
import { downloadRegisterResultDocxFile } from 'apis/registerResult';

const useDownloadRegisterResultDocxFile = () => useMutation(downloadRegisterResultDocxFile);

export default useDownloadRegisterResultDocxFile;
